import type { FunctionalComponent } from 'vue'
import './styles/virtual-table-header.scss'

export const VirtualTableHeader: FunctionalComponent = (_, { slots }) => {
  return <div class={'virtual-table__header'}>{slots.default?.()}</div>
}
